import React, { Component } from "react";
import {
  Layout,
  Breadcrumb,
  Table,
  PageHeader,
  Space,
  Row,
  Col,
  DatePicker,
  Select,
  notification,
  Button,
} from "antd";
import PieChartPlannedIntervention from "./PieChartPlannedIntervention";
import { RightOutlined } from "@ant-design/icons";

import { all as AllStats } from "../../api/SurgicalProceduresStats";
import { all as AllCareUnit } from "../../api/CareUnit.js";
import { all as AllSurgicalProcedure } from "../../api/SurgicalProcedure";
import { all as AllDoctors } from "../../api/User";

import { formatFirstname, formatLastname } from '../../utils';

import { Config } from "../../config";
import { COLUMNS } from "./constants";
import moment from "moment";
import locale from 'antd/lib/locale/fr_FR';

const { Content } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  filterOption: false,
  defaultActiveFirstOption: false,
  style: {
    width: '100%'
  }
};

/**
 *
 */
class InterventionByProcedureStats extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.title = "Statistiques des interventions par procédure";

    this.state = {
      surgicalProceduresStats: [],
      loading: false,
      total: 0,
      pagination: {
        current: 1,
        pageSize: 10
      },
      firstDay: moment().subtract(1, "weeks"),
      lastDay: moment(),
      careUnits: [],
      selectedCareUnitIds: [],
      surgicalProcedures: [],
      selectedSurgicalProcedureId: null,
      doctors: [],
      selectedDoctorId: null
    };

    this.userTable = React.createRef();
    this.timeOutFetchDoctors = null;
    this.timeOutFetchSurgicalProcedures = null;

    this.onSearchSurgicalProcedure = this.onSearchSurgicalProcedure.bind(this);

    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeSurgicalProcedure = this.onChangeSurgicalProcedure.bind(this);
    this.onChangeDoctor = this.onChangeDoctor.bind(this);

    this.exportClick = this.exportClick.bind(this);

    this.onChangeCareUnits = this.onChangeCareUnits.bind(this);
  }

  componentDidMount() {
    this.fetch();
    this.fetchCareUnits();
    this.fetchDoctors();
  }

  getPayload() {
    let {
      pagination,
      selectedCareUnitIds,
      selectedSurgicalProcedureId,
      selectedDoctorId
    } = this.state;

    let payload = { ...pagination };
    if (selectedCareUnitIds.length) {
      payload['care_unit_ids'] = selectedCareUnitIds;
    }

    if (!!selectedSurgicalProcedureId || !!selectedDoctorId) {
      payload['q'] = {};

      if (!!selectedSurgicalProcedureId) {
        payload['q']['surgical_procedure_id'] = this.state.selectedSurgicalProcedureId;
      }
      if (!!selectedDoctorId) {
        payload['q']['doctor_id'] = this.state.selectedDoctorId;
      }
    }

    return payload;
  }

  fetch() {
    this.setState({ loading: true }, () => {
      let payload = this.getPayload();
      let { firstDay, lastDay } = this.state;

      AllStats(payload, firstDay, lastDay)
        .then((data) => {
          this.setState({
            surgicalProceduresStats: data.results,
            total: data.total,
            loading: false
          });
        });
    });
  }

  /**
   * 
   * @returns 
   */
  fetchCareUnits() {
    return AllCareUnit({
      current: 1,
      pageSize: 100,
      q: {},
    })
      .then((data) => {
        this.setState({ careUnits: data.results });
      });
  }

  /**
   * 
   */
  fetchDoctors() {
    AllDoctors({
      current: 1,
      pageSize: 10,
      q: {
        'role_id': 2
      }
    })
      .then((data) => {
        this.setState({ doctors: data.results });
      });
  }

  /**
   * 
   * @param {*} search 
   */
  fetchSurgicalProcedures(search) {
    AllSurgicalProcedure({
      current: 1,
      pageSize: 10,
      q: {
        search
      }
    })
      .then((data) => {
        this.setState({ surgicalProcedures: data.results });
      });
  }

  /**
   * 
   * @param {*} value
   */
  onSearchSurgicalProcedure(value) {
    clearTimeout(this.timeOutFetchSurgicalProcedures);
    if (!value) {
      this.setState({ surgicalProcedures: [] });
      return;
    }

    this.timeOutFetchSurgicalProcedures = setTimeout(() => {
      this.fetchSurgicalProcedures(value);
    }, 500);
  };

  /**
   * 
   * @param {*} dates 
   * @param {*} dateStrings 
   */
  onChangeDate(dates, dateStrings) {
    if (dates === null) {
      let firstDay = moment().subtract(1, "weeks");
      let lastDay = moment();
      dates = [firstDay, lastDay];
    }

    this.setState({
      firstDay: dates[0],
      lastDay: dates[1],
    }, () => {
      this.fetch();
    });
  }

  /**
   *
   * @param {*} value
   */
  onChangeCareUnits(value) {
    this.setState({ selectedCareUnitIds: value }, () => {
      this.fetch();
    });
  }

  /**
   * 
   * @param {*} value 
   */
  onChangeSurgicalProcedure(value) {
    if (!value) {
      value = null;
    }

    this.setState({ selectedSurgicalProcedureId: value }, () => {
      this.fetch();
    });
  }

  /**
   * 
   * @param {*} value 
   */
  onChangeDoctor(value) {
    if (!value) {
      value = null;
    }

    this.setState({ selectedDoctorId: value }, () => {
      this.fetch();
    });
  }

  exportClick() {
    let { surgicalProceduresStats, firstDay, lastDay } = this.state;
    if (!surgicalProceduresStats.length) {
      notification['error']({ message: 'Aucunes statistiques à exporter' });
      return;
    }

    let url = Config.apiUrl
      + "/surgical_procedures/stats/export"
      + "?start_at=" + firstDay.format('YYYYMMDD')
      + "&end_at=" + lastDay.format('YYYYMMDD')
      + "&jwt=" + localStorage.getItem('token_auth');

    window.open(url);
  }

  render() {
    let {
      surgicalProceduresStats,
      careUnits,
      doctors,
      surgicalProcedures,
      firstDay,
      lastDay,
      pagination,
      loading
    } = this.state;

    let interventionPlanned = 0;
    let interventionUnPlanned = 0;

    let data = surgicalProceduresStats.map((surgical_procedure) => {
      interventionPlanned = interventionPlanned + surgical_procedure.stats.current_planned;
      interventionUnPlanned = interventionUnPlanned + surgical_procedure.stats.current_unplanned;

      return ({
        surgical_procedure_name: surgical_procedure.name,
        start: surgical_procedure.stats.start,
        current: surgical_procedure.stats.current,
        end: surgical_procedure.stats.end,
        average_expected_time: surgical_procedure.stats.average_expected_time,
        average_real_time: surgical_procedure.stats.average_real_time,
        end_by_expected_end_at: surgical_procedure.stats.end_by_expected_end_at,
        end_not_by_expected_end_at: surgical_procedure.stats.end_not_by_expected_end_at,
        current_planned: surgical_procedure.stats.current_planned,
        current_unplanned: surgical_procedure.stats.current_unplanned,
        expected_siips_base: surgical_procedure.stats.expected_siips.base,
        expected_siips_technical: surgical_procedure.stats.expected_siips.technical,
        expected_siips_relational: surgical_procedure.stats.expected_siips.relational,
        real_siips_base: surgical_procedure.stats.real_siips.base,
        real_siips_technical: surgical_procedure.stats.real_siips.technical,
        real_siips_relational: surgical_procedure.stats.real_siips.relational,
      });
    });

    let columnsTables = [...COLUMNS];
    columnsTables.unshift({
      title: "Procédure",
      dataIndex: "surgical_procedure_name",
      sorter: false,
      width: 200,
      fixed: 'left',
    });

    const dataPieChart = [
      { name: "Plannifées", value: interventionPlanned },
      { name: "Non-plannifiées", value: interventionUnPlanned }
    ];

    let careUnitOptions = careUnits.map((option, index) => (
      <Option key={index} value={option.id}>{option.name}</Option>
    ));

    let doctorOptions = doctors.map((option, index) => (
      <Option key={index} value={option.id}>
        {[formatFirstname(option.firstname), formatLastname(option.lastname)].join(' ')}
      </Option>
    ));

    let surgicalProcedureOptions = surgicalProcedures.map((option, index) => (
      <Option key={index} value={option.id}>{option.name}</Option>
    ));

    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Reporting</Breadcrumb.Item>
          <Breadcrumb.Item>{this.title}</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader ghost={false} title={this.title} />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Space className="mb-4" direction="horizontal" align="end">
              <Space direction="vertical">
                <label>Dates :</label>
                <RangePicker
                  format="DD/MM/YYYY"
                  locale={locale}
                  ranges={{
                    "Aujourd'hui": [moment(), moment()],
                    "Cette semaine": [
                      moment().startOf("week"),
                      moment().endOf("week"),
                    ],
                    "Ce mois": [
                      moment().startOf("month"),
                      moment().endOf("month"),
                    ],
                    "Les 7 derniers jours": [moment().subtract(7, 'days'), moment()],
                    "Les 7 prochains jours": [moment(), moment().add(7, 'days')],
                    "Les 30 derniers jours": [moment().subtract(30, 'days'), moment()]
                  }}
                  defaultValue={[firstDay, lastDay]}
                  onChange={this.onChangeDate}
                />
              </Space>
              <Button type="secondary" onClick={this.exportClick}>
                Exporter
              </Button>
            </Space>
            <Row className="mb-4" style={{ width: "100%" }}>
              <Col span={8} className="pr-3">
                <label>Unité(s) de soin(s) :</label>
                <Select
                  {...layoutSelect}
                  mode="multiple"
                  placeholder="Choisissez votre/vos unité(s)"
                  onChange={this.onChangeCareUnits}
                >
                  {careUnitOptions}
                </Select>
              </Col>
              <Col span={8} className="pr-3">
                <label>Procédure :</label>
                <Select
                  {...layoutSelect}
                  placeholder="Sélectionnez une procedure"
                  onSearch={this.onSearchSurgicalProcedure}
                  onChange={this.onChangeSurgicalProcedure}
                  notFoundContent="Tapez pour rechercher une procedure"
                >
                  {surgicalProcedureOptions}
                </Select>
              </Col>
              <Col span={8}>
                <label>Chirurgien :</label>
                <Select
                  {...layoutSelect}
                  placeholder="Sélectionnez un chirurgien"
                  onChange={this.onChangeDoctor}
                >
                  {doctorOptions}
                </Select>
              </Col>
            </Row>
          </Space>
          <Table
            columns={columnsTables}
            bordered
            rowKey={(record) => record.id}
            dataSource={data}
            pagination={pagination}
            loading={loading}
            scroll={{ x: 2500 }}
          />
        </div>
        <br />
        <PageHeader
          ghost={false}
          title={"Répartition des interventions plannifées sur les non-plannifiées"}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          {(surgicalProceduresStats.length > 0) ? (
            <PieChartPlannedIntervention data={dataPieChart} />
          ) : null}
        </div>
      </Content>
    );
  }
}

export default InterventionByProcedureStats;
